import { render, staticRenderFns } from "./FieldOptions.vue?vue&type=template&id=31be0e15&scoped=true&"
import script from "./FieldOptions.vue?vue&type=script&lang=js&"
export * from "./FieldOptions.vue?vue&type=script&lang=js&"
import style0 from "./FieldOptions.vue?vue&type=style&index=0&id=31be0e15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be0e15",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QBtn,QList,QItem,QItemSection,QDialog});
